/* istanbul ignore file */
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOpenDialog } from 'mf_core/dialog';
import {
  PostMsg,
  startListening,
  stopListening,
  respondToMsgWith,
} from '@im/post-msg';

export function useProcessPostMsgs() {
  const openDialog = useOpenDialog();
  const navigate = useNavigate();

  const onMsgReceived = useCallback(
    (msg: PostMsg) => {
      switch (msg.action) {
        case 'navigate':
          navigate(msg.details as string);
          break;
        case 'navigateWithProps': {
          const details = msg.details as any;
          navigate(details.route as string, {
            state: { sentProps: details.props },
          });
          break;
        }
        // Naviagtion implemented for Renewals (SPLA) to Checkout
        case 'navigateFromSPLAtoCheckout': {
          const details = msg.details as any;
          navigate(details.route as string, {
            state: { ...details.props },
          });
          break;
        }
        case 'openDialog':
          {
            const { dialogId, dialogParams } = msg.details as any;

            let onClose = undefined;
            // If request and known source
            if (msg.msgType === 'ask' && msg.msgFrom) {
              onClose = (answer?: unknown) => {
                // console.log('respondTo', msg.msgId, answer);
                respondToMsgWith(msg, answer);
              };
            }

            openDialog(dialogId, dialogParams, onClose);
          }
          break;

        default:
          console.warn('[useProcessPostMsgs] unknown message:', msg);
      }
    },
    [navigate, openDialog]
  );

  useEffect(() => {
    startListening(onMsgReceived);
    return () => {
      stopListening();
    };
  }, [onMsgReceived]);
}
